/** Campo de código de cuenta con sugerencias (código y nombre) de las cuentas imputables. */
import type { CtbAccountDto } from '@toga/shared'

interface Props {
  value: string
  onChange: (code: string) => void
  accounts: CtbAccountDto[]
  listId: string
  className?: string
  disabled?: boolean
}

export function AccountDatalist({ id, accounts }: { id: string; accounts: CtbAccountDto[] }) {
  return (
    <datalist id={id}>
      {accounts
        .filter((a) => a.isPostable && !a.blocked)
        .map((a) => (
          <option key={a.id} value={a.code}>
            {a.name}
          </option>
        ))}
    </datalist>
  )
}

export default function AccountInput({
  value,
  onChange,
  accounts,
  listId,
  className,
  disabled,
}: Props) {
  const found = accounts.find((a) => a.code === value)
  return (
    <div className="min-w-0">
      <input
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, ''))}
        inputMode="numeric"
        placeholder="Cuenta"
        disabled={disabled}
        className={className}
      />
      <p
        className={[
          'text-[10px] mt-0.5 truncate',
          found ? 't-faint' : value ? 'text-rose-300' : 't-faint',
        ].join(' ')}
      >
        {found ? found.name : value ? 'Cuenta inexistente o no imputable' : ' '}
      </p>
    </div>
  )
}
